import { Card, Col, Table } from 'reactstrap'
import { AddprojectAndUpload, Date, Price, ProjectName, Status } from '../../../../../Utils/Constants'
import AddProjectsAndUploadTableBody from './AddProjectsAndUploadTableBody'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const AddProjectsAndUpload = () => {
  return (
    <Col md="12">
      <Card>
        <CardHeaderCommon title={AddprojectAndUpload} tagClass="card-title mb-0" />
        <div className="table-responsive add-project theme-scrollbar">
          <Table className="card-table table-vcenter text-nowrap">
            <thead className='bg-light-primary'> 
              <tr>
                <th>{ProjectName}</th>
                <th>{Date}</th>
                <th>{Status}</th>
                <th>{Price}</th>
                <th />
              </tr>
            </thead>
            <AddProjectsAndUploadTableBody />
          </Table>
        </div>
      </Card>
    </Col>
  )
}

export default AddProjectsAndUpload